// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Afidium
import { SectorTravellerComponent } from './sector-traveller.component';
import { TravellerDataTranslationModule } from "libraries/service/traveller-data-translation/traveller-data-translation.module";

@NgModule({
    imports: [
        CommonModule,
        TravellerDataTranslationModule,
    ],
    declarations: [
        SectorTravellerComponent,
    ],
    exports: [
        SectorTravellerComponent,
    ],
    providers: [
    ]
})
export class SectorTravellerModule {}